const app_params = {
	basepath: '/opac',
	version: '10.0.0',
	gaTag: 'G-TAG',
	otherSite: 'https://cirma.org.gt/',
	librarySite: 'https://cirma.org.gt',
};

export default app_params;
